export interface IExpandableCheckboxListItem {
  id: string;
  label: string;
  previewUrl?: string;
}

export class ExpandableCheckboxListItem implements IExpandableCheckboxListItem {
  constructor(
    public id: string,
    public label: string,
    public previewUrl?: string,
  ) {}
}
